import { createFileRoute } from "@tanstack/react-router";
import { KaraokePage } from "../../../pages/karaoke-page/karaoke-page";

export const Route = createFileRoute("/_auth/_frame/karaoke")({
  component: KaraokePage,
});
